import axios from "./axiosConfig";
import { apis } from './params';

export function blockCustomerService(_body: any) {
    return axios({
        "method": "Post",
        "url": apis.BLOCK_CUSTOMER,
        "data": _body
    })
}